export interface TeamMember {
  name: string
  role: string
  idle: string
  voice: string
  idleWebm: string
  voiceWebm: string
  zIndex: string
  top?: string
  transform?: string
}

const MOV = 'https://mentordata-acazgce6cvdzgng9.z02.azurefd.net/cache/macos-onboarding'
const WEBM = 'http://demoassets.touchcast.com/napster-pc/onboarding'

export const kaiData: TeamMember = {
  name: 'Kai',
  role: 'Chief of Staff',
  idle: `${MOV}/Companion%205%20-%20Idle.mov`,
  voice: `${MOV}/Companion%205%20-%20Idle%20%2B%20Hey.mov`,
  idleWebm: `${WEBM}/Companion%205%20-%20Idle.webm`,
  voiceWebm: `${WEBM}/Companion%205%20-%20Idle%20%2B%20Hey.webm`,
  zIndex: `z-50`,
  top: 'top-[30px]',
}

export const team: TeamMember[] = [
  {
    name: 'JC',
    role: 'Code Wizard',
    idle: `${MOV}/Companion%201%20-%20Idle.mov`,
    voice: `${MOV}/Companion%201%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%201%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%201%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-10`,
    top: 'top-[65px]',
    transform: '[transform:translateZ(-200px)]',
  },
  {
    name: 'Elena',
    role: 'Wellbeing Guide',
    idle: `${MOV}/Companion%202%20-%20Idle.mov`,
    voice: `${MOV}/Companion%202%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%202%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%202%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-20`,
    top: 'top-[30px]',
    transform: '[transform:translateZ(-150px)]',
  },
  {
    name: 'Kevin',
    role: 'Financial Guide',
    idle: `${MOV}/Companion%203%20-%20Idle.mov`,
    voice: `${MOV}/Companion%203%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%203%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%203%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-30`,
    top: 'top-[90px]',
    transform: '[transform:translateZ(-100px)]',
  },
  {
    name: 'May',
    role: 'Creative Guru',
    idle: `${MOV}/Companion%204%20-%20Idle.mov`,
    voice: `${MOV}/Companion%204%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%204%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%204%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-40`,
    transform: '[transform:translateZ(-50px)]',
    top: 'top-[25px]',
  },
  kaiData,
  {
    name: 'Jordan',
    role: 'Fitness Coach',
    idle: `${MOV}/Companion%206%20-%20Idle.mov`,
    voice: `${MOV}/Companion%206%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%206%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%206%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-40`,
    top: 'top-[50px]',
    transform: '[transform:translateZ(-50px)]',
  },
  {
    name: 'Alyssa',
    role: 'Career Coach',
    idle: `${MOV}/Companion%207%20-%20Idle.mov`,
    voice: `${MOV}/Companion%207%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%207%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%207%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-30`,
    top: 'top-[40px]',
    transform: '[transform:translateZ(-100px)]',
  },
  {
    name: 'Richard',
    role: 'Learning Mentor',
    idle: `${MOV}/Companion%208%20-%20Idle.mov`,
    voice: `${MOV}/Companion%208%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%208%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%208%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-20`,
    top: 'top-[70px]',
    transform: '[transform:translateZ(-150px)]',
  },
  {
    name: 'Amit',
    role: 'Tech Support',
    idle: `${MOV}/Companion%209%20-%20Idle.mov`,
    voice: `${MOV}/Companion%209%20-%20Idle%20%2B%20Voice.mov`,
    idleWebm: `${WEBM}/Companion%209%20-%20Idle.webm`,
    voiceWebm: `${WEBM}/Companion%209%20-%20Idle%20%2B%20Voice.webm`,
    zIndex: `z-10`,
    top: 'top-[90px]',
    transform: '[transform:translateZ(-200px)]',
  },
]

export const featureVideo =
    'https://mentordata-acazgce6cvdzgng9.z02.azurefd.net/cache/macos-onboarding/Companion%205%20-%20Main%20Features%20Video.mp4'